module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video_bg_1-c88d5017108bd7dcae99ad0f26f5c475.svg";